import React from 'react';
import { accountManagers } from '../../../utils';
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent
} from '../../../components/ui/tooltip';

const TooltipInfo = ({ accountOwner, accountStatus, clientFlags }) => {
  const accountManager = (accountOwner) => {
    const accountManager = accountManagers.find(
      (manager) => manager.id === accountOwner
    );

    if (accountManager) {
      return accountManager.full_name;
    } else {
      return '';
    }
  };

  const getIconColorClass = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-[hsl(220,56%,47%)] text-white'; // blue
      case 'Cancelled':
        return 'bg-destructive text-destructive-foreground'; // red
      case 'Retention':
        return 'bg-[hsl(45,100%,51%)] text-white'; // yellow
      default:
        return 'bg-destructive text-destructive-foreground'; // red for any other status
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center justify-center h-5 w-5 rounded-full text-xs font-bold cursor-pointer ml-2 shrink-0 ${getIconColorClass(
              accountStatus
            )}`}>
            i
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="right"
          className="text-sm space-y-1 max-w-xs bg-white text-foreground border border-border shadow-lg">
          <p>
            <span className="font-semibold">Account Manager:</span>{' '}
            {accountManager(accountOwner) || 'N/A'}
          </p>
          <p>
            <span className="font-semibold">Account Status:</span>{' '}
            {accountStatus || 'N/A'}
          </p>
          {clientFlags && clientFlags.length > 0 && (
            <p>
              <span className="font-semibold">Notes:</span>{' '}
              {clientFlags.map((flag) => flag.replace(/_/g, ' ')).join(', ')}
            </p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TooltipInfo;
